import React from "react";
import { useTranslation } from "react-i18next";
import { formatScorePositivoData, formatToUpperFirstLetter } from "../../../../utils/utils";
import DataField from "../../../../utils/DataField";


function ScorePositivoBasicDataCard (props){

  const { data } = props
  
  const { t } = useTranslation()
  
  let addressList = []
  for (let keyData of Object.keys(data.addresses[0])) {
    if (data.addresses[0][keyData] !== null) {
      if (keyData !== "uf") {
        addressList.push(formatToUpperFirstLetter(data.addresses[0][keyData]))
      }
      else {
        addressList.push(data.addresses[0][keyData])
      }
    }
  }
  let address = ""
  if (addressList.lenght!==0){
    address = addressList.join(", ")
  }

  let phonesList = []
  for (let phone of data.phones) {
    let formatted_phone = `${phone.country_code} (${phone.area_code}) `;
    if (phone.number.length === 8) {
      formatted_phone = formatted_phone + `${phone.number.substring(0, 4)}-${phone.number.substring(4, 8)}`;
    } else if (phone.number.length === 9) {
      formatted_phone = formatted_phone + `${phone.number.substring(0, 5)}-${phone.number.substring(5, 9)}`;
    } else {
      formatted_phone = formatted_phone + phone.number;
    }

    phonesList.push(formatted_phone)
  }
  let phones = ""
  if (phonesList.length!==0){
    phones = phonesList.join("\n")
  }
  
  const firstColumnData = ["document_number","cpf_region","name","mother_name","birthdate","nationality","gender","marital_status"]
  const isInColumn = (keyData,columnData) => {
    if (columnData.includes(keyData)) return true
    else return false
  }

  return (
    <div  className="avoidPageBreakInside" style={{padding:"10px"}}>
      <div className="analysisCard" style={{height:"100%"}}>
        <div className={["blueText", "subtitleSize"].join(" ")} style={{marginBottom: "10px"}}>{t("basic_data")}
        </div>
        <div style={{display:"grid", gridTemplateColumns:"50% 50%"}}>
          <div style={{display: "flex", flexDirection: "column"}}>
            {Object.keys(data).map((keyData, index)=>(
              isInColumn(keyData,firstColumnData)&&
                <DataField
                    key={index}
                    title={t(keyData)}
                    label={data[keyData] ? formatScorePositivoData(keyData,data[keyData]) : " - "}
                    size={"normalMediumSize"}
                    titleNoWrap={false}
                />
            ))}
          </div>
          <div style={{display: "flex", flexDirection: "column"}}>
            {phones &&
              <DataField
                  title={t("phones")}
                  label={phones ? phones : " - "}
                  size={"normalMediumSize"}
                  titleNoWrap={false}
              />}
            {address &&
              <DataField
                  title={t("address")}
                  label={address ? address : " - "}
                  size={"normalMediumSize"}
                  titleNoWrap={false}
              />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScorePositivoBasicDataCard